import { exchangeRates } from 'exchange-rates-api'

export const ACTIONS = {
    GET_EXCHANGE_RATES: 'GET_EXCHANGE_RATES',
    TOGGLE_POPUP_LOCALE: 'TOGGLE_POPUP_LOCALE',
}

export const getExchangeRates =
    (errorCallback) =>
    async dispatch => {
        try {
            const data = await exchangeRates().setApiBaseUrl('https://open.er-api.com/v6').latest().base('GBP').symbols(['EUR', 'GBP']).fetch()

            dispatch({ type: ACTIONS.GET_EXCHANGE_RATES, data })
        } catch (error) {
            console.log('Error: getExchangeRates', error)
            errorCallback && errorCallback()
        }
    }

export const togglePopupLocale = bool => dispatch => dispatch({ type: ACTIONS.TOGGLE_POPUP_LOCALE, data: bool })
